
import draggable from "vuedraggable";
import { mapMutations, mapGetters, mapState } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";
import MenuCategoryOptionTile from "./menu-category-option-tile.vue";
export default {
  components: { draggable, MenuCategoryOptionTile, CurrencyConverter },
  props: {
    attribute: {
      default: () => {},
      type: Object
    },
    propName: {
      default: "",
      type: String
    },
    propValue: {
      default: "",
      type: [String, Number, undefined]
    },
    subPropName: {
      default: "",
      type: String
    },
    subPropValue: {
      default: "",
      type: [String, Number, undefined]
    },
    isSubcategory: {
      default: false,
      type: Boolean
    },
    itemProp: {
      default: () => {},
      type: Object
    },
    parentItemProp: {
      default: () => {},
      type: Object
    },
    ShowOptionTile: {
      default: false,
      type: Boolean
    },
    noSubcategoryAssigned: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      dragging: false,
      cardItems: [],
      selected: []
    };
  },

  created() {},
  mounted() {
    this.$nuxt.$on("clear-menu-upload-item-selection", () => {
      this.selected = [];
    });
  },
  computed: {
    ...mapGetters("menu", ["getMenuUploadItemsByProp"]),
    ...mapState("menu", ["menuUploadDragSelection"]),
    isAllSelected() {
      return (
        this.itemsList.length > 0 &&
        this.selected.length === this.itemsList.length
      );
    },
    itemsList: {
      get() {
        let items = this.getMenuUploadItemsByProp(
          this.subPropName ? this.subPropName : this.propName,
          this.propValue === ""
            ? undefined
            : this.subPropValue
            ? this.subPropValue
            : this.propValue
        );
        if (this.noSubcategoryAssigned) {
          items = items.filter((item) => {
            return item.category_id === this.propValue && !item.sub_category_id;
          });
        }

        return items;
      },
      set(value) {
        this.cardItems = value;
      }
    }
  },
  methods: {
    ...mapMutations("menu", [
      "SET_MENU_UPLOAD_LIST_PROP",
      "SET_MENU_UPLOAD_DRAG_SELECTION"
    ]),
    dragstart() {
      this.SET_MENU_UPLOAD_DRAG_SELECTION(this.selected);
    },
    dragEnd() {
      this.$nuxt.$emit("clear-menu-upload-item-selection");
    },
    dragChange(el) {
      if (el.added) {
        let ids;
        if (this.menuUploadDragSelection?.length) {
          ids = this.menuUploadDragSelection;
        } else {
          ids = [el.added.element?.id];
        }
        this.SET_MENU_UPLOAD_LIST_PROP({
          ids,
          propName: this.propName,
          propValue: this.propValue,
          subPropName: this.subPropName,
          subPropValue: this.subPropValue
        });
        this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
        this.selected = [];
      } else if (el.removed) {
        this.selected = [];
      }
      // console.log(this.cardItems);
    },
    handleSelectAll() {
      if (this.selected?.length === this.itemsList.length) {
        // Deselect all items
        this.selected = [];
        this.SET_MENU_UPLOAD_DRAG_SELECTION(
          this.menuUploadDragSelection.filter(
            (item) => !this.itemsList.map((el) => el.id).includes(item)
          )
        );
      } else {
        // Select all items
        this.selected = this.itemsList.map((el) => el.id);
        const newSelected = [
          ...new Set([...this.menuUploadDragSelection, ...this.selected])
        ];
        this.SET_MENU_UPLOAD_DRAG_SELECTION(newSelected);
      }
    },
    updateSelected(itemId) {
      let isChecked = this.selected.includes(itemId);
      if (!isChecked) {
        const selectedItems = this.menuUploadDragSelection.filter(
          (item) => item !== itemId
        );
        this.SET_MENU_UPLOAD_DRAG_SELECTION(selectedItems);
      } else {
        const newSelected = [...this.menuUploadDragSelection, ...this.selected];
        this.SET_MENU_UPLOAD_DRAG_SELECTION(newSelected);
      }
    }
  },

  unmounted() {
    this.$nuxt.$off("clear-menu-upload-item-selection");
  }
};
